(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deckaud-collection-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('deckaud-collection-story')) return;

    class DeckaudCollectionStory extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-collection-story-track]');
        this.previousButton = this.querySelector('[data-collection-story-previous]');
        this.nextButton = this.querySelector('[data-collection-story-next]');
        if (!this.track) return;

        this.previousButton?.addEventListener('click', () => this.scroll(-1));
        this.nextButton?.addEventListener('click', () => this.scroll(1));
        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        this.resizeHandler = () => this.updateButtons();
        window.addEventListener('resize', this.resizeHandler);
        this.updateButtons();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.resizeHandler);
      }

      scroll(direction) {
        const card = this.track.querySelector('.deckaud-collection-story__card');
        if (!card) return;
        const styles = window.getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      updateButtons() {
        if (!this.previousButton || !this.nextButton) return;
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.previousButton.disabled = this.track.scrollLeft <= 2;
        this.nextButton.disabled = this.track.scrollLeft >= maximum - 2;
      }
    }

    customElements.define('deckaud-collection-story', DeckaudCollectionStory);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deckaud-video-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('deckaud-video-story')) return;

    class DeckaudVideoStory extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('[data-video-story-toggle]');
        this.autoplay = this.dataset.autoplay === 'true';
        this.pausedByUser = !this.autoplay;

        this.toggleButton?.addEventListener('click', () => this.togglePlayback());
        this.visibilityHandler = () => {
          if (document.hidden) {
            this.pauseVideos(false);
          } else if (!this.pausedByUser) {
            this.playVisibleVideo();
          }
        };
        this.resizeHandler = () => {
          this.pauseVideos(false);
          if (!this.pausedByUser) this.playVisibleVideo();
        };

        document.addEventListener('visibilitychange', this.visibilityHandler);
        window.addEventListener('resize', this.resizeHandler);

        if (this.autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.pausedByUser = false;
          this.playVisibleVideo();
        } else {
          this.pausedByUser = true;
          this.pauseVideos(true);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        window.removeEventListener('resize', this.resizeHandler);
        this.pauseVideos(false);
      }

      visibleVideo() {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const preferred = mobile
          ? this.querySelector('.deckaud-video-story__video--mobile')
          : this.querySelector('.deckaud-video-story__video--desktop');

        return preferred || this.querySelector('video');
      }

      playVisibleVideo() {
        this.querySelectorAll('video').forEach((video) => {
          if (video !== this.visibleVideo()) video.pause();
        });

        const video = this.visibleVideo();
        if (!video) return;
        video.muted = true;
        const promise = video.play();
        if (promise?.catch) promise.catch(() => this.pauseVideos(true));
        this.classList.remove('is-paused');
        this.toggleButton?.setAttribute('aria-label', 'Pause video');
        this.toggleButton?.setAttribute('aria-pressed', 'true');
      }

      pauseVideos(updateState) {
        this.querySelectorAll('video').forEach((video) => video.pause());
        if (!updateState) return;
        this.classList.add('is-paused');
        this.toggleButton?.setAttribute('aria-label', 'Play video');
        this.toggleButton?.setAttribute('aria-pressed', 'false');
      }

      togglePlayback() {
        const video = this.visibleVideo();
        if (!video) return;

        if (video.paused) {
          this.pausedByUser = false;
          this.playVisibleVideo();
        } else {
          this.pausedByUser = true;
          this.pauseVideos(true);
        }
      }
    }

    customElements.define('deckaud-video-story', DeckaudVideoStory);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
